(function() {
	'use strict';

	class DCY_TYPES_ENUM {

		constructor(name, icon, type){
			this.name = name;
			this.type = type;
			this.icon = icon;
		}
		
		getName() {
			return this.name;
		}
		
		getType() {
			return this.type;
		}
		
		getIcon() {
			return this.icon;
		}
		
		static getEnumByType(type) {
			let rtn = null;
			Object.keys(DCY_TYPES_ENUM.TYPES).forEach((key) => {
				let dcyType = DCY_TYPES_ENUM.TYPES[key];
				if (dcyType.getType() == type)
					rtn = dcyType;
			});
			return rtn;
		}
	}

	DCY_TYPES_ENUM.TYPES = {
			'REPORT'		: new DCY_TYPES_ENUM('Report'		, 'view-comfy'				, 1),
			'MASHBOARD'		: new DCY_TYPES_ENUM('Mashboards'	, 'dashboard'			, 121),
			'TASK'			: new DCY_TYPES_ENUM('Tasks'		, 'assignment_turned_in', 372),
			'USER'			: new DCY_TYPES_ENUM('Users'		, 'account-multiple'	, 500),
			'DOCUMENT'		: new DCY_TYPES_ENUM('Documents'	, 'dcy-document-icon'	, 1004),
			'AREA'			: new DCY_TYPES_ENUM('Areas'		, 'dcy-area-icon'		, 1005),
			'BLOG'			: new DCY_TYPES_ENUM('BlogPosts'	, 'blogger'				, 1006),
			'SIGNAL'		: new DCY_TYPES_ENUM('signals'		, 'share-variant'		, 1007),
			'GROUP'			: new DCY_TYPES_ENUM('Groups'		, 'dcy-group-icon'		, 1010),
			'INITIATIVE'	: new DCY_TYPES_ENUM('Initiatives'	, 'dcy-initiative-icon'	, 1011)
	};
	
	window.DCY_TYPES_ENUM = DCY_TYPES_ENUM;
}());



	
	
	